module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./commonAgreementView.js"));
	}, "CommonAgreementView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CommonAgreementView!./src/pages/Shop/Member/Agreements/commonAgreement/commonAgreementView.js
// module id = 950
// module chunks = 438